import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Skeleton,
  IconButton,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const COLUMN_COUNT = 5;

const SkeletonTableRow = ({ height = 16, sx }) => (
  <Box
    sx={{
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1,
      ...sx,
    }}
  >
    {Array.from({ length: COLUMN_COUNT }).map((_, index) => (
      <Box key={index} sx={{ flex: 1, minWidth: 0 }}>
        <Skeleton variant="text" width="100%" height={height} />
      </Box>
    ))}
  </Box>
);

const CrossingTradeRebalancerSkeleton = ({
  openCrossPopup,
  handleClose,
  showNext,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={openCrossPopup}
      maxWidth="sm"
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "560px",
          height: "90vh",
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          backgroundColor: theme.palette.background.paper,
        },
      }}
    >
      <DialogTitle
        sx={{
          flexShrink: 0,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            component="div"
            align="left"
            sx={{ flexGrow: 1, fontSize: "20px", color: theme.palette.text.primary }}
          >
            Orders
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{ color: theme.palette.text.secondary }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Box
          sx={{
            flex: "1 1 0px",
            minHeight: 0,
            overflow: "hidden",
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "4px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              px: 1.5,
              py: 1.5,
              borderBottom: `1px solid ${theme.palette.divider}`,
              flexShrink: 0,
            }}
          >
            <SkeletonTableRow height={24} />
          </Box>

          <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden", px: 1.5, py: 1.5 }}>
            {Array.from({ length: 20 }).map((_, index) => (
              <SkeletonTableRow
                key={index}
                height={16}
                sx={{ mb: 1, py: 0.5 }}
              />
            ))}
          </Box>
        </Box>

        {showNext && (
          <Box
            sx={{
              flexShrink: 0,
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
              py: 1,
            }}
          >
            <Skeleton
              variant="rectangular"
              width="40%"
              height={40}
              sx={{ borderRadius: 1 }}
            />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CrossingTradeRebalancerSkeleton;
